<template>
  <div>
    <app-cells>
      <app-button @click.native="onShowModal">Import</app-button>
    </app-cells>
    <app-cells>
      <div class="date-picker-wrapper">
        <VueCtkDateTimePicker
          id="date_picker_balance"
          class="custom-date-time-picker custom-date-time-picker--range"
          v-model="filter_dates"
          :custom-shortcuts="custom_shortcuts"
          @is-hidden="onIsHiddenPicker"
          format="YYYY-MM-DD"
          formatted="ll"
          label="Select dates"
          color="#77b017"
          button-color="#77b017"
          overlay
          no-header
          no-label
          locale="en"
          range
        />
        <div v-if="date_picker_error" class="date-picker-wrapper__error">Choose an end date</div>
      </div>
      <app-input
        @input.native="onSearch"
        v-model="filter_search"
        class="input--300"
        type="search"
        placeholder="Search"
        name="search_invoice"
      />
    </app-cells>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <app-cells><h2 class="title">Unallocated Outcome</h2></app-cells>
      <v-client-table
        :data="table_outcome.items"
        :columns="table_outcome.columns"
        :options="table_outcome.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader_outcome }"
      >
        <template #h__account><div class="table-default__left">Account</div></template>
        <template #h__description><div class="table-default__left">Description</div></template>
        <template #h__reference><div class="table-default__left">Reference</div></template>
        <template #h__select>
          <label
            v-if="table_outcome.items.length"
            class="checkbox checkbox--table"
          >
            <input
              v-model="checked_all_outcome"
              type="checkbox"
              name="checked_all_outcome"
            />
            <span class="checkbox__checkmark"></span>
          </label>
        </template>
        <template #select="{ row }">
          <label class="checkbox checkbox--table">
            <input
              v-model="checked_outcome"
              type="checkbox"
              :value="row.id"
            />
            <span class="checkbox__checkmark"></span>
          </label>
        </template>
        <template #account="{ row }"><div class="table-default__left table-default__nowrap">{{ row.account.name }}</div></template>
        <template #date="{ row }"><span class="table-default__nowrap">{{ dateTimeFormat(row.timestamp) }}</span></template>
        <template #reference="{ row }"><div class="table-default__left">{{ row.reference }}</div></template>
        <template #description="{ row }"><div class="table-default__left">{{ row.description }}</div></template>
        <template #amount="{ row }">
          <span class="table-default__nowrap" :class="{'table-default__text-green': row.type === 1, 'table-default__text-red': row.type === 2}">
          {{ amountFormat(row.amount) }} {{ row.account.currency.code }}
          </span>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPaginationOutcome"
            v-if="pagination_outcome.pages > 1"
            v-model="pagination_outcome.page"
            :page-count="pagination_outcome.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_outcome.count" :count="table_outcome.items.length" :page="pagination_outcome.page" :limit="40" />
      </app-cells>
      <app-cells><h2 class="title">Allocated</h2></app-cells>
      <v-client-table
        :data="table_allocated.items"
        :columns="table_allocated.columns"
        :options="table_allocated.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader_allocated }"
      >
        <template #h__account><div class="table-default__left">Account</div></template>
        <template #h__description><div class="table-default__left">Description</div></template>
        <template #h__reference><div class="table-default__left">Reference</div></template>
        <template #h__rule><div class="table-default__left">Rule</div></template>
        <template #account="{ row }"><div class="table-default__left table-default__nowrap">{{ row.account.name }}</div></template>
        <template #date="{ row }"><span class="table-default__nowrap">{{ dateTimeFormat(row.timestamp) }}</span></template>
        <template #reference="{ row }"><div class="table-default__left">{{ row.reference }}</div></template>
        <template #description="{ row }"><div class="table-default__left">{{ row.description }}</div></template>
        <template #amount="{ row }">
          <span class="table-default__nowrap" :class="{'table-default__text-green': row.type === 1, 'table-default__text-red': row.type === 2}">
          {{ amountFormat(row.amount) }} {{ row.account.currency.code }}
          </span>
        </template>
        <template #rule="{ row }"><div class="table-default__left">{{ row.rule?.description || row.rule?.pattern || '-' }}</div></template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPaginationAllocated"
            v-if="pagination_allocated.pages > 1"
            v-model="pagination_allocated.page"
            :page-count="pagination_allocated.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_allocated.count" :count="table_allocated.items.length" :page="pagination_allocated.page" :limit="40" />
      </app-cells>
      <div class="flying-block" :class="{ 'flying-block--show': is_show_flying_block }">
        <div class="flying-block__text">
          Selected items: {{ checked_outcome.length }}
        </div>
        <app-button @click.native="onShowAllocateModal" >Allocate</app-button>
      </div>
    </template>
    <modal
      name="import_modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      :reset="true"
      class="modal-not-overflow"
      draggable=".popup__title"
    >
      <div class="popup">
        <button @click="$modal.hide('import_modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Import Kassa Statement</div>
        <div class="popup__body">
          <form @submit.prevent="onSendImport">
            <app-form-group label="Period" required>
              <app-date-picker
                v-model="period"
                range
                :clearable="false"
                placeholder="Period"
              />
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button ref="submit" type="submit">Import</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="allocate_modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      :reset="true"
      class="modal-not-overflow"
      draggable=".popup__title"
    >
      <div class="popup">
        <button @click="$modal.hide('allocate_modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Allocate</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm('form_allocate', 'sendAllocate')">
            <app-form-group label="Supplier">
              <app-select
                @input="onSelectSupplier"
                @search="onSupplierSearch"
                v-model="form_allocate.supplier"
                :options="supplier_options"
                :filterBy="() => true"
                :display-field="option => `${option.trade_name === option.legal_name ? option.trade_name : `${option.trade_name} (${option.legal_name})`}`"
                label="trade_name"
                placeholder="Supplier"
              />
            </app-form-group>
            <app-form-group label="Item" required>
              <app-select
                v-model="form_allocate.item"
                :options="transaction_items_options_outcome"
                :clearable="false"
                label="name_expense"
                placeholder="Item"
                :error="$v.form_allocate.item.$error"
              />
              <template #error>
                <div v-if="$v.form_allocate.item.$dirty && !$v.form_allocate.item.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Notes" label-for="notes">
              <app-textarea
                v-model="form_allocate.description"
                rows="5"
                placeholder="Notes"
                id="notes"
              />
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button ref="submit_allocate" type="submit">Allocate</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  getAdministrativeSuppliers,
  getFinanceCashflowReconciliation,
  postFinanceCashflowReconciliationTransactions,
  postFinanceReconciliationImportKassa,
  getFinanceTransactionsItemsList
} from '@/http'
import moment from 'moment/moment'
import debounce from 'lodash/debounce'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { format, parseISO, subDays } from 'date-fns'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'FinanceCashflowReconciliationKassa',
  components: { VueCtkDateTimePicker },
  data() {
    return {
      page_loaded: false,
      period: [],
      filter_dates: null,
      date_picker_error: false,
      filter_search: '',
      custom_shortcuts: [
        {
          key: 'next30Days',
          label: 'Next 30 days',
          value: () => {
            return {
              start: moment(),
              end: moment().add(30, 'days')
            }
          }
        },
        {
          key: 'next60Days',
          label: 'Next 60 days',
          value: () => {
            return {
              start: moment(),
              end: moment().add(60, 'days')
            }
          }
        },
        {
          key: 'next90Days',
          label: 'Next 90 days',
          value: () => {
            return {
              start: moment(),
              end: moment().add(90, 'days')
            }
          }
        },
        { key: 'last30Days', label: 'Last 30 days', value: 30 },
        { key: 'thisYear', label: 'This year', value: 'year' },
      ],
      checked_all_outcome: false,
      checked_outcome: [],
      current_page_outcome: 1,
      form_allocate: {},
      table_outcome: {
        items: [],
        columns: [
          'select',
          'date',
          'account',
          'amount',
          'reference',
          'description',
        ],
        options: {
          headings: {
            'select': '',
            'account': 'Account',
            'date': 'Date',
            'reference': 'Reference',
            'description': 'Description',
            'amount': 'Amount',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_outcome: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader_outcome: false,
      table_allocated: {
        items: [],
        columns: [
          'date',
          'account',
          'amount',
          'reference',
          'description',
          'rule',
        ],
        options: {
          headings: {
            'account': 'Account',
            'date': 'Date',
            'reference': 'Reference',
            'description': 'Description',
            'amount': 'Amount',
            'rule': 'Rule',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_allocated: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader_allocated: false,
      is_show_flying_block: false,
      supplier_options: [],
      transaction_items_options_outcome: [],
    }
  },
  validations: {
    form_allocate: {
      item: { required },
    },
  },
  watch: {
    checked_all_outcome(value) {
      if (this.current_page_outcome !== this.pagination_outcome.page) return
      if (value) {
        this.table_outcome.items.forEach(item => {
          if (!this.checked_outcome.includes(item.id)) this.checked_outcome.push(item.id)
        })
      } else {
        this.checked_outcome = this.checked_outcome.filter(item => !this.table_outcome.items.map(subitem => subitem.id).includes(item))
      }
    },
    checked_outcome(value) {
      this.is_show_flying_block = value.length > 0
      if (!this.checked_outcome.length) this.checked_all_outcome = false
    },
  },
  mounted() {
    Promise.all([getFinanceTransactionsItemsList({ expense: true }), this.fetchItemsOutcome(), this.fetchItemsAllocated()])
      .then(response => {
        this.transaction_items_options_outcome = response[0].data
        this.page_loaded = true
      })
  },
  methods: {
    onShowAllocateModal() {
      this.form_allocate = {
        item: null,
      }
      this.$v.form_allocate.$reset()
      this.$modal.show('allocate_modal')
    },
    async fetchItemsOutcome() {
      const response = await getFinanceCashflowReconciliation({
        page: this.pagination_outcome.page,
        page_size: 40,
        is_allocated: false,
        is_processing: false,
        type: 2,
        source: 'kassa',
        timestamp__gte: this.filter_dates?.start,
        timestamp__lte: this.filter_dates?.end,
        search: this.filter_search,
      })
      this.table_outcome.items = response.data.results
      this.pagination_outcome.pages = response.data.pages
      this.pagination_outcome.count = response.data.count
      this.table_preloader_outcome = false
    },
    async fetchItemsAllocated() {
      const response = await getFinanceCashflowReconciliation({
        page: this.pagination_allocated.page,
        page_size: 40,
        is_allocated: true,
        source: 'kassa',
        timestamp__gte: this.filter_dates?.start,
        timestamp__lte: this.filter_dates?.end,
        search: this.filter_search,
      })
      this.table_allocated.items = response.data.results
      this.pagination_allocated.pages = response.data.pages
      this.pagination_allocated.count = response.data.count
      this.table_preloader_allocated = false
    },
    async onClickPaginationOutcome(page) {
      this.pagination_outcome.page = page
      await this.fetchItemsOutcome()
      this.checked_all_outcome = this.checked_outcome.some(item => this.table_outcome.items.map(subitem => subitem.id).includes(item))
      this.$nextTick(() => { this.current_page_outcome = page })
    },
    onClickPaginationAllocated(page) {
      this.pagination_allocated.page = page
      this.fetchItemsAllocated()
    },
    onCheckForm(form, action) {
      this.$v[form].$touch()
      if (this.$v[form].$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this[action]()
      }
    },
    onSendImport() {
      this.$refs.submit.preload = true
      postFinanceReconciliationImportKassa({ from_date: this.period[0], to_date: this.period[1] })
        .then(() => {
          this.fetchTables()
          this.$notify({
            type: 'success',
            title: 'Imported',
          })
          this.$modal.hide('import_modal')
        })
        .catch(() => { this.$refs.submit.preload = false })
    },
    sendAllocate() {
      this.$refs.submit_allocate.preload = true
      const data = {...this.form_allocate}
      if (data.supplier) data.supplier = data.supplier.id
      else delete data.supplier
      data.reconciliations = this.checked_outcome
      data.item = data.item.id
      postFinanceCashflowReconciliationTransactions(data)
        .then(() => {
          this.pagination_outcome.page = 1
          this.current_page_outcome = 1
          this.fetchTables()
          this.checked_outcome = []
          this.$notify({
            type: 'success',
            title: 'Allocated',
          })
          this.$modal.hide('allocate_modal')
        })
        .catch(() => { this.$refs.submit_allocate.preload = false })
    },
    onShowModal() {
      this.period = [format(subDays(new Date(), 2), 'yyyy-MM-dd'), format(new Date(), 'yyyy-MM-dd')]
      this.$modal.show('import_modal')
    },
    async fetchTables() {
      await Promise.all([
        this.fetchItemsOutcome(),
        this.fetchItemsAllocated(),
      ])
    },
    onIsHiddenPicker() {
      if (this.filter_dates?.start && this.filter_dates?.end) {
        this.date_picker_error = false
        this.fetchTables()
      } else this.date_picker_error = true
    },
    onSearch() {
      this.searchItem(this)
    },
    searchItem: debounce(async vm => {
      vm.pagination_outcome.page = 1
      vm.pagination_allocated.page = 1
      vm.current_page_outcome = 1
      await vm.fetchTables()
      vm.checked_all_outcome = vm.checked_outcome.some(item => vm.table_outcome.items.map(subitem => subitem.id).includes(item))
    }, 350),
    dateTimeFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : '-'
    },
    amountFormat(amount) {
      return amount ? new Intl.NumberFormat('ru-RU').format(amount) : '-'
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
    onSupplierSearch(search, loading) {
      loading(true)
      this.searchSupplier(loading, search, this)
    },
    searchSupplier: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.supplier_options = []
      } else {
        getAdministrativeSuppliers({search}).then(response => {
          vm.supplier_options = response.data
          loading(false)
        })
      }
    }, 350),
    onSelectSupplier(e) {
      if (e?.transaction_item) this.form_allocate.item = e.transaction_item
      else this.form_allocate.item = null
    },
  }
}
</script>
